module.exports = __webpack_public_path__ + "img/logo.5130a2d9.png";